import React from "react";

function ExploreHeading(props){
    return <section className="breadcrumbs">
    <div className="container">

      <h2>{props.title}</h2>

    </div>
  </section>
}

export default ExploreHeading;